import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';


@Injectable()
export class SharedAPIService {
    
    private termsAndConditions:any;
    private currencyData:any;
    private documentPurpose:any;
    private documentRisk:any;
    private documentNotice:any;
    private productCategoryMap:any = {
                                    LowRisk : 'low',
                                    ModerateRisk : 'moderate',
                                    HighRisk : 'high'

                                    };
    productCategoryMapReverse:any = {
                                        low : 'LowRisk',
                                        moderate : 'ModerateRisk',
                                        high : 'HighRisk'
    
                                        }
    

    private frequencyData:any;

    private redirectionType:String = '';

    private docusignStatus = "";

    constructor(private httpClient: HttpClient) { }

    getProductsFromPegaTable(table:any){
        
        const categoryList = Object.keys(table);
        let productList:never[] = []
        let count = 0;
        
        categoryList.forEach(category=>{
            
            if(table[category].map){
                productList = productList.concat(table[category].map((product:any)=>{
                    
                    return {
                        Id: count++,
                        RiskLevel:this.productCategoryMap[category] ,
                        Title: product.ProductName,
                        Description: product.ProductDescription,
                        IsChecked : product.pySelected
                    }
                }))
            }
        })
        
        return productList
    }
    
    setDocusignClicked(object:any){
        this.setSessionStorage('digital-fna-docusign-clicked',object);
    }

    getDocusignClicked(){
        return this.getSessionStorage('digital-fna-docusign-clicked')
    }

    setAcceptAssessedRiskProfile(object:any){
        this.setSessionStorage('digital-fna-AcceptAssessedRiskProfile',object);
    }

    getAcceptAssessedRiskProfile(){
        return this.getSessionStorage('digital-fna-AcceptAssessedRiskProfile')
    }

    setUniqueLink(link:string){
        window.localStorage.setItem('digital-fna-unique-link',link)
    }

    getUniqueLink(){
        return this.getSessionStorage('digital-fna-unique-link')
    }

    setAssessedRiskProfile(object:any){
        this.setSessionStorage('digital-fna-assessed-risk-profile',object);
    }

    getAssessedRiskProfile(){
        return this.getSessionStorage('digital-fna-assessed-risk-profile')
    }

    setSessionStorage(id:string,object:any){
        sessionStorage.setItem(id,JSON.stringify(object))
    }

    getSessionStorage(id:string){
        let jsonStringLstring = ''
        jsonStringLstring =""+sessionStorage.getItem(id)
        return jsonStringLstring=="undefined"?undefined:JSON.parse(jsonStringLstring)
    }

    setSessionStorageSimple(id:string,object:any){
        sessionStorage.setItem(id,JSON.stringify({'item':object}))
        
    }

    getSessionStorageSimple(id:string){
       
        let jsonStringLstring = ''
        jsonStringLstring =""+sessionStorage.getItem(id)
        let finalObj = jsonStringLstring=="undefined"?undefined:JSON.parse(jsonStringLstring)
        return finalObj.item
    }

    storeProductDetailsToSS(productDetail :any){
        sessionStorage.setItem('digital-fna-product-details',JSON.stringify(productDetail))
    }

    retrieveProductDetails(){
        let jsonStringLstring = ''
        jsonStringLstring =""+sessionStorage.getItem('digital-fna-product-details')
        return jsonStringLstring=="undefined"?undefined:JSON.parse(jsonStringLstring)
    }

    setTableABDesc(tableABDesc:any){
        sessionStorage.setItem('digital-fna-tableAB-info-html',JSON.stringify(tableABDesc))
    }
    getTableABDesc(){
        let jsonStringLstring = ''
        jsonStringLstring =""+sessionStorage.getItem('digital-fna-tableAB-info-html')
        return jsonStringLstring=="undefined"?undefined:JSON.parse(jsonStringLstring)
    } 

   

    setTermsAndConditions(termsAndConditions:any){
       // this.termsAndConditions = termsAndConditions
        this.setSessionStorageSimple('digital-fna-terms-and-conditions',termsAndConditions);
    }
    getTermsAndConditions(){
        return this.getSessionStorageSimple('digital-fna-terms-and-conditions')
    } 
    setCurrencyData(currencyData:any){
        this.currencyData = currencyData
    }
    getCurrencyData(){
        return this.currencyData;
    } 
    setDocumentPurpose(documentPurpose:any){
        
        this.setSessionStorageSimple('digital-fna-document-purpose',documentPurpose);
    }
    getDocumentPurpose(){
        return this.getSessionStorageSimple('digital-fna-document-purpose')
    } 
    setDocumentRisk(documentRisk:any){
        this.setSessionStorageSimple('digital-fna-document-risk',documentRisk);
    }
    getDocumentRisk(){
        return this.getSessionStorageSimple('digital-fna-document-risk')
    } 
    setDocumentNotice(documentNotice:any){
        this.setSessionStorageSimple('digital-fna-document-notice',documentNotice);
    }
    getDocumentNotice(){
        return this.getSessionStorageSimple('digital-fna-document-notice')
    } 
    setFrequencyData(frequencyData:any){
        this.frequencyData = frequencyData
    }
    getFrequencyData(){
        return this.frequencyData;
    } 

    setRedirectionType(redirectionType:string){
        window.localStorage.setItem('digital-fna-redirect-from',redirectionType)
    }
    getRedirectionType(){
        return  window.localStorage.getItem('digital-fna-redirect-from')
    } 

    setServletContextPath(contextPath:string){
        window.localStorage.setItem('digital-fna-servlet-context-path',contextPath)
    }
    getServletContextPath(){
        return  window.localStorage.getItem('digital-fna-servlet-context-path')
    } 
    

    getCorpPassAtt(request: any) {
        return this.httpClient.post("./prweb/prservices/GetCorpPassAttributes", request);
      }

    submitRiskAndObjective(request: any) {
        return this.httpClient.post("./prweb/prservices/writeService", request);
    }

    getOTPTimeOut(request: any) {
        return this.httpClient.post("./prweb/UserAuthentication/GetOTPTimeout", request);
    }

    setDocusignStatus(docusignStatus:any){
        this.docusignStatus = docusignStatus
    }
    getDocusignStatus(){
        return this.docusignStatus;
    } 

    setDocusignURL(link:any){
       
        window.localStorage.setItem('digital-fna-docusign-url',link)
    }

    getDocusignURL(){
        return window.localStorage.getItem('digital-fna-docusign-url')
    }
    
    createTableAData(table:any){
    
        const tableADetails = table
        let lowRiskHTML = '<p>'
        let moderateRiskHTML = '<p>'
        let highRiskHTML = '<p>'
        tableADetails.LowRisk.forEach((element:any) => {
          lowRiskHTML  = lowRiskHTML+"<b>"+element.ProductName+"</b><br>"+element.ProductDescription+"<br><br>"
        });
        tableADetails.ModerateRisk.forEach((element:any) => {
          moderateRiskHTML  = moderateRiskHTML+"<b>"+element.ProductName+"</b><br>"+element.ProductDescription+"<br><br>"
        });
        tableADetails.HighRisk.forEach((element:any) => {
          highRiskHTML  = highRiskHTML+"<b>"+element.ProductName+"</b><br>"+element.ProductDescription+"<br><br>"
        });
    
        return [lowRiskHTML,moderateRiskHTML,highRiskHTML]
      }


}